$(function () {
    if ($(".js-photo-share").length > 0) {
        const photo = $(".js-photo-share");

        const shareNow = async () => {
            let item = photo.find(".carousel-item.active .js-item").data('type');
            
            console.log(item);

            if (item == 'vdo') {
                let path = photo
                    .find(".carousel-item.active .-video")
                    .attr("src");

                console.log(path);

                let fileResponse = await window.fetch(path);
                let fileBuffer = await fileResponse.arrayBuffer();
                let fileArray = [
                    new File([fileBuffer], "share.mp4", {
                        type: "video/mp4",
                        lastModified: Date.now(),
                    }),
                ];

                if (
                    window.navigator &&
                    window.navigator.canShare &&
                    window.navigator.canShare({ files: fileArray })
                ) {
                    navigator
                        .share({
                            files: fileArray,
                            // title: "GC",
                        })
                        .then(() => {
                            console.log("Thanks for sharing!");
                        })
                        .catch(console.error);
                }
            } else {
                let img = photo
                    .find(".carousel-item.active .-img-slide")
                    .attr("src");
                console.log(img);

                let imageResponse = await window.fetch(img);
                let imageBuffer = await imageResponse.arrayBuffer();
                let fileArray = [
                    new File([imageBuffer], "share.png", {
                        type: "image/png",
                        lastModified: Date.now(),
                    }),
                ];

                if (
                    window.navigator &&
                    window.navigator.canShare &&
                    window.navigator.canShare({ files: fileArray })
                ) {
                    navigator
                        .share({
                            files: fileArray,
                            // title: photo.data('title'),
                            // text: photo.data('text')
                        })
                        .then(() => {
                            console.log("Thanks for sharing!");
                        })
                        .catch(console.error);
                }
            }
        };

        const shareButton = document.getElementById("btnShare");

        shareButton.addEventListener("click", function (event) {
            event.preventDefault();
            shareNow();
        });

        if (window.navigator && window.navigator.canShare) {
            photo.find(".js-hide-share").removeClass("d-none");
        }

        const saveButton = document.getElementById("btnSave");

        saveButton.addEventListener("click", function (event) {
            event.preventDefault();
            let url = photo.find(".carousel-item.active .js-item").attr("src");
            downloadImage(url);
        });

        function downloadImage(url) {
            fetch(url, {
                mode: "no-cors",
            })
                .then((response) => response.blob())
                .then((blob) => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.download = url.replace(/^.*[\\\/]/, "");
                    a.href = blobUrl;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });
        }

        $(".carousel").swipe({
            swipe: function (
                event,
                direction,
                distance,
                duration,
                fingerCount,
                fingerData
            ) {
                if (direction == "left") $(this).carousel("next");
                if (direction == "right") $(this).carousel("prev");
            },
            allowPageScroll: "vertical",
        });
    }
});
